
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.23 15.26L16.69 14.97C16.08 14.9 15.48 15.11 15.05 15.54L13.21 17.38C10.38 15.94 8.06004 13.63 6.62004 10.79L8.47004 8.93999C8.90004 8.50999 9.11004 7.90999 9.04004 7.29999L8.75004 4.77999C8.63004 3.76999 7.78004 3.00999 6.76004 3.00999H5.03004C3.90004 3.00999 2.96004 3.94999 3.03004 5.07999C3.56004 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26ZM13 11H17C17.55 11 18 10.55 18 9.99999C18 9.44999 17.55 8.99999 17 8.99999H15.41L19.72 4.68999C20.11 4.29999 20.11 3.66999 19.72 3.27999C19.33 2.88999 18.7 2.88999 18.31 3.27999L14 7.58999V5.99999C14 5.44999 13.55 4.99999 13 4.99999C12.45 4.99999 12 5.44999 12 5.99999V9.99999C12 10.55 12.45 11 13 11Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-phone-callback`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPhoneCallback

    ```js
    <b-new-b-icon-phone-callback />
    ```
</docs>


